// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"j5-z"};